import { Box, Icon, Typography } from '@core/component';
import { EColor, EIcon, ETypographyVariant } from '@core/type';

export const ProductLogisticBenefit = ({ title }: { title: string }) => (
  <Box display={'flex'} gap={'10px'}>
    <Icon type={EIcon.CHECK} color={EColor.ACCENT} strokeWidth={2} />
    <Typography variant={ETypographyVariant.BODY3} color={EColor.PRIMARY}>
      {title}
    </Typography>
  </Box>
);
